import type { HttpClient } from "../client";

export class SyncService {
	constructor(
		private _client: HttpClient,
		private _prefix = "/sync",
	) {}

	// NOTE: Maybe rename this to `stream`
	public async openSSE<TData extends Record<string, unknown>>(data: TData) {
		return this._client.post<unknown>(`${this._prefix}/`, { data });
	}
}
